// extracted by mini-css-extract-plugin
module.exports = {"tag":"YearTag-module__tag"};